import markedReviewIconLight from '../../../../../apps/frontend/public/icons/marked-review-light.svg';
import markedReviewIconDark from '../../../../../apps/frontend/public/icons/marked-review-dark.svg';

const QuestionButton = ({ question, isCurrent, isDarkTheme, onClick }) => {
  let status;
  if (question.isCorrect) status = 'Correct';
  else if (['answered', 'answeredReview'].includes(question.status)) status = 'Incorrect';
  else status = 'Unattempted';

  const baseStyle = `w-full h-full rounded text-[14px] flex items-center justify-center hover:border-b-2 hover:border-[var(--q3-neutral-default)]`;

  const normalStateClass =
    status === 'Correct'
      ? 'text-[var(--q3-success-normal)] bg-[var(--q3-success-light)]'
      : status === 'Incorrect'
        ? 'text-[var(--q3-danger-normal)] bg-[var(--q3-danger-light)]'
        : 'text-[var(--q3-neutral-default)] bg-[var(--q3-surface-dimmer)]';

  const currentStateClass =
    status === 'Correct'
      ? 'text-[var(--q3-success-light)] bg-[var(--q3-success-normal)]'
      : status === 'Incorrect'
        ? 'text-[var(--q3-danger-light)] bg-[var(--q3-danger-normal)]'
        : 'text-[var(--q3-neutral-default_inverted)] bg-[var(--q3-neutral-default)]';

  const clipPathStyle =
    status === 'Incorrect'
      ? { clipPath: 'polygon(0 0, 100% 0, 100% 75%, 70% 100%, 30% 100%, 0 75%)' }
      : status === 'Correct'
        ? { clipPath: 'polygon(30% 0, 70% 0, 100% 25%, 100% 100%, 0 100%, 0 25%)' }
        : {};

  return (
    <div className="relative w-10 h-10 cursor-pointer q3-interaction-scale-down" onClick={onClick}>
      {(question.status === 'markedReview' || question.status === 'answeredReview') && (
        <img
          src={isDarkTheme ? markedReviewIconDark : markedReviewIconLight}
          alt="Marked for Review"
          className="absolute left-[30px] right-[2px] z-10"
        />
      )}

      <div className={`${baseStyle} ${isCurrent ? currentStateClass : normalStateClass}`} style={clipPathStyle}>
        {question.qNo}
      </div>
    </div>
  );
};

export default QuestionButton;
